module.exports = __webpack_public_path__ + "assets/img/item-bg.8c802550.png";